<template>
  <el-aside
    width="200px"
    class="layout-sider-nav">
    <el-menu
      :default-active="defaultActive"
      :unique-opened="true"
      background-color="#3F3F3F"
      text-color="#BFCBD9"
      active-text-color="#fff">
      <template v-for="(menu) in menuData">
        <el-submenu
          v-if="menu.children"
          :key="menu.funcAddress"
          :index="menu.funcAddress">
          <span slot="title">{{ menu.menuName }}</span>
          <el-menu-item
            v-for="(children) in menu.children"
            :key="children.funcAddress"
            :index="children.funcAddress"
            @click="openUrl(children.funcAddress)">{{ children.menuName }}</el-menu-item>
        </el-submenu>
        <el-menu-item
          v-else
          :key="menu.funcAddress"
          :index="menu.funcAddress"
          @click="openUrl(menu.funcAddress)">
          <span slot="title">{{ menu.menuName }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </el-aside>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'LayoutSider',
  computed: {
    ...mapState({
      menu: (state) => state.account.menu
    }),
    defaultActive() {
      return this.$route.meta.activePath
    },
    menuData() {
      const activeTopPath = this.$route.meta.activeTopPath
      const menu = this.menu.find(s => s.menuId === activeTopPath) || {}
      return menu.children || []
    }
  },
  methods: {
    openUrl(url) {
      this.$router.push(url)
    }
  }
}
</script>
<style lang="stylus">
.layout-sider-nav {
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  background-color: #3F3F3F;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.5);
  z-index: 10;

  .el-menu {
    border-right: none;

    .el-menu-item {
      height: 42px;
      line-height: 42px;
    }
    .el-submenu__title {
       height: 45px;
      line-height: 45px;
    }
  }
}
</style>
